export default __webpack_public_path__ + "static/media/img14.d4322c5f.png";